
        import { BASE_MESSAGES } from '@app/core';

        export const MESSAGES = {
            ...BASE_MESSAGES
        };
        